<script setup lang="ts">
import HotMatchItem from '~/components/common/hot-match/hot-match-item.vue'
import { useHotmatches } from '~/composables/home/use-hotmatches'
const { hotmatches } = useHotmatches()
</script>
<template>
  <div v-if="hotmatches?.length" class="news-hot-matches">
    <div class="news-hot-matches__title">
      Trận đấu Hot
      <NuxtLink to="/the-thao" class="seemore"> Xem thêm </NuxtLink>
    </div>
    <div class="news-hot-matches__content">
      <HotMatchItem v-for="(hotmatch, index) in hotmatches.slice(0, 2)" :item="hotmatch" :key="index" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '~scssAsset/desktop/pages/news/news-hot-matches.scss';
</style>
